import { render, staticRenderFns } from "./StaticLoader.vue?vue&type=template&id=73722626&scoped=true"
import script from "./StaticLoader.vue?vue&type=script&lang=js"
export * from "./StaticLoader.vue?vue&type=script&lang=js"
import style0 from "./StaticLoader.vue?vue&type=style&index=0&id=73722626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73722626",
  null
  
)

export default component.exports